<div class="my-3 my-md-5">
    <div class="container">
        <div class="card">
            <mat-tab-group>
                <mat-tab label="Lead Info">
                    <form [formGroup]="leadForm" (submit)="saveLead()">
                        <div class="container-fluid p-3">
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Lead Name</label>
                                            <input class="form-control" formControlName="lead_name" placeholder="Lead Name" />
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Lead Mobile</label>
                                            <input class="form-control" formControlName="lead_mobile" readonly="" placeholder="Lead Mobile" />
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Lead City</label>
                                            <input type="text" placeholder="City" formControlName="lead_city" readonly="" class="form-control" />
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Circle</label>
                                            <mat-select placeholder="Select Circle" formControlName="circle">
                                                <mat-option>Select Circle</mat-option>
                                                <mat-option [value]="circle.id" *ngFor="let circle of circles">{{circle.name}}</mat-option>
                                            </mat-select>
                                        </div>
                                    </div>
                                </div> 
                            </div>

                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Lead Owner</label>
                                            <mat-select placeholder="Select Lead Owner" formControlName="lead_owner">
                                                <mat-option [value]="bd.id" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                                            </mat-select>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Treatment</label>
                                            <mat-select placeholder="Select Treatment" formControlName="treatment">
                                                <mat-option  [value]="treatment.id" *ngFor="let treatment of treatments">{{treatment.name}}</mat-option>
                                            </mat-select>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Description</label>
                                            <textarea class="form-control" formControlName="description"></textarea>
                                        </div>
                                    </div>
                                </div> 
                            </div>

                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Lead Status</label>
                                            <mat-select placeholder="Select Lead Status" formControlName="lead_status">
                                                <mat-option [value]="lead_status.id" *ngFor="let lead_status of leadStatus">{{lead_status.name}}</mat-option>
                                            </mat-select>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Doctor</label>
                                            <mat-select placeholder="Select Doctor" formControlName="doctor">
                                                <mat-option [value]="doctor_list.id" *ngFor="let doctor_list of doctorList">{{doctor_list.name}}</mat-option>
                                            </mat-select>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Follow Up Date</label>
                                            <mat-form-field class="example-full-width" appearance="fill">
                                                <mat-label>Choose a date</mat-label>
                                                <input matInput  formControlName="followup_date" [matDatepicker]="picker1">
                                                <mat-datepicker-toggle matSuffix [for]="picker1">
                                                </mat-datepicker-toggle>
                                                <mat-datepicker #picker1></mat-datepicker>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Payment Mode</label>
                                            <mat-select  formControlName="payment_mode" placeholder="Select Payment Mode">
                                                <mat-option>Select</mat-option>
                                                <mat-option value="Cash">Cash</mat-option>
                                                <mat-option value="Cashless">Cashless</mat-option>
                                                <mat-option value="Reimbursement">Reimbursement</mat-option>
                                                <mat-option value="EMI">EMI</mat-option>
                                            </mat-select>
                                        </div>
                                    </div>
                                </div> 
                            </div>

                        </div>
                    </form>
                </mat-tab>
                <mat-tab label="Lead Activity"> 
                    <div class="row p-3">
                        <div class="col-sm-3"><input class="form-control" [(ngModel)]="search" type="text" (keyup)="loadLeadHistory(0,perpage)" placeholder="Search" /></div>
                        <div class="col-sm-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter a date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate #dateRangeStart placeholder="Start date">
                                    <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDate()">clear</mat-icon>
                        </div>
                        <div class="col-sm-5">
                            <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator>
                        </div>
                    </div>
                    <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                        <tbody>
                            <tr *ngFor="let history of histories">
                                <td>
                                    <div [innerHTML]="history.message | safe:'html'"></div>
                                    <div class="small text-muted">
                                        <i class="fas fa-clock"></i> {{history.created_at*1000|date:'dMMM, yyyy H:mm aa'}}
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="!histories.length && loaded">
                                <td>No history found</td>
                            </tr>
                            <tr *ngIf="loading">
                                <td><i class="fa fa-spin fa-spinner"></i></td>
                            </tr>
                        </tbody>
                    </table>
                    <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
                </mat-tab>
            </mat-tab-group>

            
        </div>
        
    </div>
</div>